import { Global, css } from '@emotion/react'
import { useTheme } from '@mui/system'
import type { Theme } from '@mui/system'

const styles = (props: { theme: Theme }) => css`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-size: 16px;
    line-height: 1.5em;
  }

  body,
  p,
  span,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  button {
    font-family: ${props.theme.d.font.primary};
  }

  a,
  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  /* Browsers pick their own placeholder grey (Chrome's reads 3.5:1 here); use
     ours, and undo Firefox's extra fade. */
  ::placeholder {
    color: ${props.theme.d.colors.grey};
    opacity: 1;
  }

  h1 {
    line-height: 100%;
  }

  .dzu-previewButton {
    height: inherit;
    width: 20px;
  }

  .dzu-previewButton-cancel::after {
    cursor: pointer;
    content: '⏸︎';
  }

  .dzu-previewButton-remove::after {
    cursor: pointer;
    content: '✕';
  }

  .dzu-previewButton-restart::after {
    cursor: pointer;
    content: '⏵︎';
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      transition-duration: 0.01ms !important;
      transition-delay: 0ms !important;
    }
  }
`

export function GlobalStyles() {
  const theme = useTheme()
  return <Global styles={styles({ theme })} />
}
